import { ServerType } from './tariff';

export const defaultCurrency = 'USD'; // валюта по-умолчанию
export const defaultServer = ServerType.MT5;
